/* eslint-disable import/prefer-default-export */
import marketDomain from './domain';

export const domain = marketDomain;
